import * as React from "react";
const SvgFiRrTachometerAltAverage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20 4.052a12 12 0 0 0-16.388 17.52A5 5 0 0 0 7.12 23h9.767a4.84 4.84 0 0 0 3.354-1.288A12.054 12.054 0 0 0 20 4.052M18.867 20.26c-.541.491-1.25.756-1.98.741H7.12a3 3 0 0 1-2.11-.858 10 10 0 1 1 13.857.117M8.82 6.683a1 1 0 0 1-.248 1.392 6.03 6.03 0 0 0-.766 9.21 1 1 0 1 1-1.4 1.43 8.042 8.042 0 0 1 1.02-12.28 1 1 0 0 1 1.394.248M20 13a7.93 7.93 0 0 1-2.408 5.715 1 1 0 0 1-1.4-1.43 6.03 6.03 0 0 0-.765-9.21 1 1 0 1 1 1.143-1.64A8.01 8.01 0 0 1 20 13m-6 0a2 2 0 1 1-3-1.732V6a1 1 0 0 1 2 0v5.268A2 2 0 0 1 14 13"
    />
  </svg>
);
export default SvgFiRrTachometerAltAverage;
